// A theme's 3D view as Unity draws it (setViewportTheme): every colour solid #rrggbb, a see-through token laid over what it sits on.
import { rgbToHex, themeValues, tokenColour, type Rgb, type TokenColour } from './colour';

/** A theme's 3D colours as #rrggbb: Unity's sky gradient, ground and grid, and the preview canvases' grid lines. */
export type ViewportColors = { skyTop: string; skyBottom: string; floor: string; grid: string; gridStrong: string };

/** A colour as it shows over `under`: a see-through colour mixed with it by its opacity, a solid one as it is. */
export function laidOver(colour: TokenColour | null, under: Rgb): Rgb {
  if (!colour) return under;
  return colour.alpha >= 1 ? colour.rgb : (colour.rgb.map((channel, i) => channel * colour.alpha + under[i] * (1 - colour.alpha)) as Rgb);
}

/** The 3D view for a set's tokens: the sky from its top into its bottom, the ground and its grid lines over the ground; each a solid colour, a see-through one (which a set shouldn't hold) laid over the surface. */
export function viewportOf(tokens: Record<string, string>, mode: 'light' | 'dark'): ViewportColors {
  const valueOf = themeValues(tokens, mode);
  const surface = tokenColour('lureo-surface', valueOf)?.rgb ?? [255, 255, 255];
  const floor = laidOver(tokenColour('lureo-viewport-floor', valueOf), surface);
  return {
    skyTop: rgbToHex(laidOver(tokenColour('lureo-viewport-sky-top', valueOf), surface)),
    skyBottom: rgbToHex(laidOver(tokenColour('lureo-viewport-sky-bottom', valueOf), surface)),
    floor: rgbToHex(floor),
    grid: rgbToHex(laidOver(tokenColour('lureo-viewport-grid', valueOf), floor)),
    gridStrong: rgbToHex(laidOver(tokenColour('lureo-viewport-grid-strong', valueOf), floor)),
  };
}
